"use client";

import { useState, useEffect, useRef, useCallback } from "react";

const DEBOUNCE_MS = 500;

export function useDebouncedQuery(query: string) {
  const [debouncedQuery, setDebouncedQuery] = useState(query);
  const timerReference = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    timerReference.current = setTimeout(() => {
      setDebouncedQuery(query);
    }, DEBOUNCE_MS);

    return () => {
      if (timerReference.current) clearTimeout(timerReference.current);
    };
  }, [query]);

  const overrideDebouncedQuery = useCallback((value: string) => {
    if (timerReference.current) clearTimeout(timerReference.current);
    setDebouncedQuery(value);
  }, []);

  return { debouncedQuery, overrideDebouncedQuery };
}
